// extracted by mini-css-extract-plugin
export default {"layout":"FullWidthLayout-module-layout-1wxba"};